import PropTypes from 'prop-types'
import { Button, Card } from 'reactstrap'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'

/**
 *
 * @param {Object} paymentMethod - selected payment method in Checkout Page
 * @param {Function} handdleClickChooseButton - function to open up Modal in Checkout Page
 */
const CustomerCheckoutPaymentMethodCard = ({ paymentMethod, handleClickChooseButton }) => (
  <Card className='p-3 shadow'>
    {
      paymentMethod
        ? (
          <div className='d-flex align-items-center'>
            <img
              className='checkout__input-label-img pr-3'
              style={{ width: '5rem' }}
              src={ `${WEB_URL_CONSTANTS.HOMEPAGE}/${paymentMethod.logo_url}` }
            />
            <small>{ paymentMethod.name }</small>
          </div>
        )
        : (
          <div className='d-flex align-items-center justify-content-between '>
            <strong>Pilih Metod</strong>
            <Button
              outline
              size='sm'
              color='primary'
              onClick={ () => handleClickChooseButton() }
            >
              Choose Payment
            </Button>
          </div>
        )
    }
  </Card>
)

CustomerCheckoutPaymentMethodCard.defaultProps = {
  paymentMethod           : undefined,
  handleClickChooseButton : () => { alert('handleClickChooseButton()')}
}

CustomerCheckoutPaymentMethodCard.propTypes = {
  paymentMethod: PropTypes.shape({
    logo_url : PropTypes.string,
    name     : PropTypes.string
  }),
  handleClickChooseButton: PropTypes.func
}

export default CustomerCheckoutPaymentMethodCard